<div *transloco="let t" class="flex h-screen flex-col items-center justify-center gap-6 bg-background-primary px-4">
  <img alt="Pixacare logo" class="max-w-48" src="https://cdn.pixacare.com/logo/left-transparent.svg" />
  <div tuiTitle>
    <h1 class="text-center">
      {{ t("Vous n'êtes rattaché à aucun établissement.") }}
    </h1>
    <p class="text-balance text-center" tuiSubtitle>
      {{ t("Si vous souhaitez continuer d'utiliser Pixacare, n'hésitez pas à contacter le service support.") }}
    </p>
  </div>

  <div class="flex w-auto flex-col items-center justify-center gap-2">
    <button appearance="primary" class="w-full" size="m" tuiButton type="button" (click)="openContactUsForm()">
      {{ t('Nous contacter') }}
    </button>
    <button appearance="outline" class="w-full" size="m" tuiButton type="button" (click)="logout()">
      {{ t('Déconnexion') }}
    </button>
  </div>
</div>
